import { OrderPackage } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { createSelectOptions } from "Infrastructure/Utilities/Helpers/createSelectOptions";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import Select, {
	type OptionType,
} from "Shared/Components/Form/CustomFormComponent/Select";
import { useFormContext } from "react-hook-form";

type PackageTypeCardWidgetProps = {
	isDisabled?: boolean;
};

const orderResources = Resources.base.order.editForm;
const selectOptionsResources = Resources.base.order.selectOptions;

export function PackageTypeCardWidget({
	isDisabled = false,
}: PackageTypeCardWidgetProps) {
	const { t } = useResource();
	const {
		control,
		formState: { errors },
	} = useFormContext();

	// Empty option lets an admin clear the package type (sent as null on save).
	const options: OptionType[] = [
		{ value: "", label: t(orderResources.packageTypeNone) },
		...createSelectOptions(OrderPackage, t, selectOptionsResources.packageType),
	];

	return (
		<BaseCard title={t(orderResources.packageType)}>
			<Select
				id="packageType"
				name="packageType"
				variant="outlined"
				control={control}
				errors={errors}
				options={options}
				fullWidth
				disabled={isDisabled}
			/>
		</BaseCard>
	);
}
